import {Signal} from '@angular/core';

export abstract class RouteVisibilityPort {
  abstract readonly isOnProductsRoute: Signal<boolean>;
}
